import {
  StandardNumber,
  StandardNumberType,
} from "@tlc/ls2pac/dto/StandardNumber";

function getStandardNumbersByType(
  standardNumbers: StandardNumber[] | null | undefined,
  type: StandardNumberType
): string[] {
  if (!standardNumbers) {
    return [];
  }

  const upperType = type.toUpperCase();
  return standardNumbers
    .filter((sn) => sn.type.toUpperCase() === upperType)
    .map((sn) => sn.data);
}

export function getISBNList(
  standardNumbers: StandardNumber[] | null | undefined
) {
  return getStandardNumbersByType(standardNumbers, StandardNumberType.Isbn);
}

export function getUPCList(
  standardNumbers: StandardNumber[] | null | undefined
) {
  return getStandardNumbersByType(standardNumbers, StandardNumberType.Upc);
}
